import { Outlet } from "react-router-dom";

export default function HealthScoreLayout() {
  return <Outlet />;
}
